<template>
  <div>
    <v-select :items="operators" label="Select Operator" v-model="estimate.bookingMadeBy"/>
    <v-text-field v-model.number="estimate.days" label="Number of Days"/>
    <v-select v-model="activeNote" :items="notes" label="Quick Enter Note" item-text="name" item-value="name"/>
    <v-textarea v-model="estimate.notes" label="Notes"/>
    <v-textarea v-model="estimate.hiddenNotes" label="Hidden Notes"/>
    <v-text-field prefix="£" v-model.number="estimate.total" label="Total excluding VAT"/>
    <v-text-field v-model="estimate.discountNotes" label="Discount Note"/>
    <v-text-field v-model.number="estimate.discountValue" label="Discount Value"/>
    <h4 v-if="estimate.discountValue > 0 && renderComponent" class="display-1">Total Including VAT -
      £{{ parseFloat((estimate.total - estimate.discountValue) + (estimate.total - estimate.discountValue) * 0.20).toFixed(2) }}</h4>
    <h4 v-if="!estimate.discountValue && renderComponent" class="display-1">Total Including VAT -
      £{{ parseFloat(estimate.total + estimate.total * 0.20).toFixed(2) }}</h4>
    <v-btn color="info" @click="createSubEstimate">Create a Sub Estimate</v-btn>

    <v-dialog v-model="subEstimateDialog" width="50%" persistent>
      <v-card>
        <v-card-title>Create a sub estimate</v-card-title>
        <v-card-text>
          <v-text-field label="Sub Estimate Name" v-model="subEstimate.name" />
          <v-textarea v-model="subEstimate.notes" label="Sub Estimate Notes"/>
          <v-tabs vertical v-model="tab">
            <v-tab>
              <v-icon left>mdi-image-broken-variant</v-icon>
              Damage
            </v-tab>
            <v-tab class="text-left">
              <v-icon left>mdi-account-tie</v-icon>
              Contractors
            </v-tab>
            <v-tab>
              <v-icon left>mdi-tools</v-icon>
              Parts
            </v-tab>
            <v-tab-item>
              <v-card flat>
                <v-card-text>
                  <estimate-damage embedded :estimate="subEstimate" v-on:estimate-damage-selected="updateTotals" />
                </v-card-text>
              </v-card>
            </v-tab-item>
            <v-tab-item>
              <v-card flat>
                <v-card-text>
                  <estimate-contractors :estimate="subEstimate" />
                </v-card-text>
              </v-card>
            </v-tab-item>
            <v-tab-item>
              <v-card flat>
                <v-card-text>
                  <estimate-parts embedded v-on:estimate-part-added="subPartAdded" v-on:estimate-part-removed="subPartRemoved" :estimate="subEstimate" />
                </v-card-text>
              </v-card>
            </v-tab-item>
            <v-tab-item>
              <v-card flat>
                <v-card-text>
                  <estimate-details :estimate="subEstimate" />
                </v-card-text>
              </v-card>
            </v-tab-item>
          </v-tabs>
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn @click="cancelCreateSubEstimate">Cancel</v-btn>
          <v-btn color="success" @click="addSubEstimate">Add Sub Estimate</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import {NotesHttp} from "@/http/notes";
import EstimateParts from "@/components/modals/estimate/sections/EstimateParts";
import EstimateContractors from "@/components/modals/estimate/sections/EstimateContractors";
import EstimateDamage from "@/components/modals/estimate/sections/EstimateDamage";
import {toAmount} from "@/helper/amount";

export default {
  name: "EstimateDetails",
  components: {EstimateParts, EstimateContractors, EstimateDamage},
  props: {
    estimate: Object
  },
  async mounted() {
    this.notes = await NotesHttp.getAllNotes();
  },
  watch: {
    activeNote(newVal) {
      if (!this.estimate.notes || this.estimate.notes.length === 0) {
        this.estimate.notes = `${newVal}`;
      } else {
        this.estimate.notes = this.estimate.notes + `\n${newVal}`;
      }
      this.activeNote = '';
    }
  },
  data() {
    return {
      operators: [
        'Nick',
        'Mike'
      ],
      notes: [],
      activeNote: '',
      selectedDay: 1,
      selectedTotal: 0,
      selectedIsPdr: false,
      selectedIsAlloys: false,
      selectedIsCCar: false,
      renderComponent: true,
      subEstimateDialog: false,
      subEstimate: {},
      tab: null,
    }
  },
  methods: {
    forceRerender() {
      // Remove my-component from the DOM
      this.renderComponent = false;

      this.$nextTick(() => {
        // Add the component back in
        this.renderComponent = true;
      });
    },
    createSubEstimate() {
      this.subEstimateDialog = true;
      this.subEstimate = {};
    },
    cancelCreateSubEstimate() {
      this.subEstimate = {};
      this.subEstimateDialog = false;
    },
    addSubEstimate() {
      if (!this.estimate.subEstimates) {
        this.estimate.subEstimates = [];
      }
      this.estimate.subEstimates.push(this.subEstimate);
      this.$emit('sub-estimates-updated', this.estimate.subEstimates);
      this.subEstimateDialog = false;
    },
    updateTotals() {
      this.subEstimate.total = 0;
      if (this.subEstimate.damage) {
        this.subEstimate.damage.forEach(damage => {
          this.subEstimate.total = this.subEstimate.total + toAmount(damage.labour);
        });
      }
      if (this.subEstimate.parts) {
        this.subEstimate.parts.forEach(part => {
          this.subEstimate.total = this.subEstimate.total + toAmount(part.price);
        });
      }
    },
    subPartAdded(part) {
      if (!this.subEstimate.parts) {
        this.subEstimate.parts = [];
      }
      this.subEstimate.parts.push(part);
      this.updateTotals();
    },
    subPartRemoved(name) {
      this.subEstimate.parts.splice(this.subEstimate.parts.findIndex(x => x.name === name), 1);
      this.updateTotals();
    }
  }
}
</script>
